import React from 'react';
import styled from 'styled-components';
import Colors from '../../ui/global/Colors';
import Fonts from '../../ui/global/Fonts';
import TopBar from '../website/TopBar';
import Button from '../../ui/components/Button';
import Hero from '../website/Hero';
import GameGallery from './components/GameGallery';
import { useNavigate, useLocation } from 'react-router-dom';
import RainbowButton from '../website/RainbowButton';
import CursorEffect from '../../ui/components/CursorEffect';
import Footer from '../website/Footer';
import VideoPlayer from '../website/VideoPlayer';

const Root = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    min-height: 100svh;
    background-color: ${Colors.black};
    color: ${Colors.white};
    padding: 5px 5px 0 5px;
    // margin-top: 54px;
    gap: 10px;
    overflow-x: hidden;
    overflow-y: auto;
`;

const InitialContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    text-align: center;
    margin: 0;
    margin-bottom: 40px;
    gap: 20px;
    overflow: visible;
`;

const InitialButtonContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: fit-content;
    margin: 10px;
    margin-top: 30px;
    gap: 10px;
    z-index: 2;

    @media (max-width: 768px) {
        gap: 2px;
    }
`;

interface HomeProps {

}

const Home = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const tabs = []; //[{ name: 'Community' }];

    const onStartCreatingClick = () => {
        localStorage.setItem('redirectPath', location.pathname);
        navigate('/signup', { state: { from: location } });
    };
    
    const primaryButton = (
        <InitialButtonContainer>
            <RainbowButton color='white' text="Start Creating" onClick={onStartCreatingClick} />
        </InitialButtonContainer>
    );

    const demoVideoUrl = "https://cegqyfnwjaxjtssjnmda.supabase.co/storage/v1/object/public/playmix-assets/website/playmix_demo.mp4";
    const demoCaptionsUrl = "https://cegqyfnwjaxjtssjnmda.supabase.co/storage/v1/object/public/playmix-assets/website/playmix_demo_captions.vtt";

    return (
        <Root>
            <TopBar type='Game' colorMode='dark'/>
            <InitialContainer>
                <Hero 
                    title="AI Game Maker" 
                    subtitle="Idea to playable game in seconds."
                    children={primaryButton} 
                />
                <VideoPlayer videoUrl={demoVideoUrl} captions={demoCaptionsUrl} />
                <GameGallery colormode="dark" tabs={tabs} />
                <CursorEffect colorMode="dark"/>
            </InitialContainer>
            <Footer colorMode='dark'/>
        </Root>
    )
};

export default Home;